import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockStatisticsFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 * Lazy per the block-loading rule: not on the critical rendering path.
 */
export const statisticsBlockConfig = {
  name: 'inner-block-statistics',
  component: defineAsyncComponent(() => import('./CmsStatisticsBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./StatisticsBlock.vue')),
  fields: blockStatisticsFields,
} satisfies ModularBlockConfig;
